export default function QRCodeIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path
        className="cls-1"
        d="M79.35,162.84h-13c-3.31,0-6-2.69-6-6v-90.5c0-3.31,2.69-6,6-6h90.5c3.31,0,6,2.69,6,6v13c0,3.31-2.69,6-6,6h-71.5v71.5c0,3.31-2.69,6-6,6Z"
      />
      <path
        className="cls-1"
        d="M433.65,163.37h-13c-3.31,0-6-2.69-6-6v-71.5h-71.5c-3.31,0-6-2.69-6-6v-13c0-3.31,2.69-6,6-6h90.5c3.31,0,6,2.69,6,6v90.5c0,3.31-2.69,6-6,6Z"
      />
      <path
        className="cls-1"
        d="M433.65,439.66h-90.5c-3.31,0-6-2.69-6-6v-13c0-3.31,2.69-6,6-6h71.5v-71.5c0-3.31-2.69-6,6-6h13c3.31,0,6,2.69,6,6v90.5c0,3.31-2.69,6-6,6Z"
      />
      <path
        className="cls-1"
        d="M156.84,439.13h-90.5c-3.31,0-6-2.69-6-6v-90.5c0-3.31,2.69-6,6-6h13c3.31,0,6,2.69,6,6v71.5h71.5c3.31,0,6,2.69,6,6v13c0,3.31-2.69,6-6,6Z"
      />
      <path
        className="cls-1"
        d="M221.69,373.58h-85.57c-3.72,0-6.74-3.02-6.74-6.74v-85.57c0-3.72,3.02-6.74,6.74-6.74h85.57c3.72,0,6.74,3.02,6.74,6.74v85.57c0,3.72-3.02,6.74-6.74,6.74ZM157.46,345.49h42.88v-42.88h-42.88v42.88Z"
      />
      <path
        className="cls-1"
        d="M221.69,231.49h-85.57c-3.72,0-6.74-3.02-6.74-6.74v-85.57c0-3.72,3.02-6.74,6.74-6.74h85.57c3.72,0,6.74,3.02,6.74,6.74v85.57c0,3.72-3.02,6.74-6.74,6.74ZM157.46,203.39h42.88v-42.88h-42.88v42.88Z"
      />
      <path
        className="cls-1"
        d="M363.83,231.49h-85.57c-3.72,0-6.74-3.02-6.74-6.74v-85.57c0-3.72,3.02-6.74,6.74-6.74h85.57c3.72,0,6.74,3.02,6.74,6.74v85.57c0,3.72-3.02,6.74-6.74,6.74ZM299.6,203.39h42.88v-42.88h-42.88v42.88Z"
      />
      <rect
        className="cls-1"
        x="271.52"
        y="274.52"
        width="99.06"
        height="99.06"
        rx="6"
        ry="6"
      />
    </svg>
  );
}